<template>
    <b-container fluid>
        <BlogHome :category="category"/>
    </b-container>
</template>

<script>
    import BlogHome from '@/components/BlogHome'
    export default {
        name: "BlogTS",
        components: {BlogHome},

        data() {
            return {
                category: 'techstars'
            }
        }

    }
</script>